/* eslint-disable import/no-cycle */

import { call, put, takeEvery } from 'redux-saga/effects';
import { course } from '../../api/api';
import {
  CREATE_COURSE,
  CREATE_COURSE_SUCCESS,
  CREATE_COURSE_FAILURE,
  ADD_COMMANDS,
  ADD_COMMANDS_SUCCESS,
  ADD_COMMANDS_FAILURE,
  CANCEL_COURSE,
  CANCEL_COURS_SUCCESS,
  CANCEL_COURS_FAILURE
} from './courseActions';

import { REMOVE_ALL_COMMANDS_IDS } from '../commands/commandsActions';
import logger from '../../utils/logger';
import { displayLoading, displaySuccess } from '../../utils/toast/Toast';

/**
 * Création d'une course
 * @param  {Object}    action action object
 */
export function* createCourse(action) {
  try {
    const closeLoading = displayLoading('Création de la course en cours');
    const response = yield call(course.create, action.payload);
    if (response.data.success === true) {
      yield put({
        type: CREATE_COURSE_SUCCESS,
        payload: { ...response.data, ...action.payload }
      });
      closeLoading();
      displaySuccess('La course a bien été créée');
      yield put({ type: REMOVE_ALL_COMMANDS_IDS });
    } else {
      yield put({ type: CREATE_COURSE_FAILURE });
      closeLoading();
    }
  } catch (error) {
    logger(error);
    yield put({ type: CREATE_COURSE_FAILURE });
  }
}

/**
 * Ajout de commande à une course en cours
 * @param  {Object}    action action object
 */
export function* addCommands(action) {
  try {
    const response = yield call(course.addCommands, action.payload);
    if (response.data.success === true) {
      yield put({ type: ADD_COMMANDS_SUCCESS, payload: response.data });
      yield put({ type: REMOVE_ALL_COMMANDS_IDS });
      displaySuccess('Les commandes ont bien été ajouté à la course');
    } else {
      yield put({ type: ADD_COMMANDS_FAILURE });
    }
  } catch (error) {
    logger(error);
    yield put({ type: ADD_COMMANDS_FAILURE });
  }
}

/**
 * Annulation d'une course
 * @param  {Object}    action action object
 */
export function* cancelCourse(action) {
  try {
    const response = yield call(course.cancel, action.payload);
    if (response.data.success) {
      yield put({ type: CANCEL_COURS_SUCCESS });
      displaySuccess('La course a bien été annulée');
    } else {
      yield put({ type: CANCEL_COURS_FAILURE });
    }
  } catch (error) {
    logger(error);
    yield put({ type: CANCEL_COURS_FAILURE });
  }
}

const courseSaga = [
  takeEvery(CREATE_COURSE, createCourse),
  takeEvery(ADD_COMMANDS, addCommands),
  takeEvery(CANCEL_COURSE, cancelCourse)
];

export default courseSaga;
